/**
 * Hooks spécialisés pour les permissions sur les catégories
 */
import { useMemo } from 'react';
import { useMultipleAuthorizations } from './useAuthorization';
import { ActionType, ModelType } from '@constants/authorization';

/**
 * Hook pour toutes les permissions sur une catégorie
 */
export const useCategoryPermissions = (categoryId) => {
  const checks = useMemo(() => {
    if (!categoryId) {
      return [];
    }

    const permissionChecks = [
      { key: 'canUpdate', action: ActionType.UPDATE, modelType: ModelType.CATEGORY, modelId: categoryId },
      { key: 'canDelete', action: ActionType.DELETE, modelType: ModelType.CATEGORY, modelId: categoryId }
    ];

    return permissionChecks;
  }, [categoryId]);

  const { permissions, loading, error, refresh } = useMultipleAuthorizations(checks);

  return {
    permissions: {
      canUpdate: permissions.canUpdate || false,
      canDelete: permissions.canDelete || false
    },
    loading,
    error,
    refresh
  };
};

/**
 * Hook pour les permissions de création de catégories
 */
export const useCategoryCreationPermission = () => {
  const checks = useMemo(() => [
    { key: 'canCreate', action: ActionType.CREATE, modelType: ModelType.CATEGORY }
  ], []);

  const { permissions, loading, error, refresh } = useMultipleAuthorizations(checks);

  return {
    canCreate: permissions.canCreate || false,
    loading,
    error,
    refresh
  };
};
